import React from 'react';

function AxesHelper({ axes }) {
  return <axesHelper args={[axes, 50, 50]} position={[0, 0, 0]} />;
}

export default AxesHelper;
